import { render, staticRenderFns } from "./user-documents-library.component.vue?vue&type=template&id=645e7718&"
import script from "./user-documents-library.component.ts?vue&type=script&lang=ts&"
export * from "./user-documents-library.component.ts?vue&type=script&lang=ts&"
import style0 from "./user-documents-library.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports